import React, { useEffect } from 'react';

const Login = () => {
    useEffect(() => {
        // As soon as this component loads, bounce them to the new portal
        // Using .replace() means they can't click the "Back" button and get stuck in a loop
        window.location.replace("https://partnerportal.bajajamc.com");
    }, []);

    // Optional: Show a quick loading message while the redirect happens
    return (
        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h2>Redirecting to the new Bajaj Portal...</h2>
        </div>
    );
};

export default Login;
export function encrypt(text) {
  const str = "acgredf7e2e";
  const str1 = "hseckahdfis234te";
  const decode = btoa(text);
  const encrpytion1 = str + decode + str1;
  const encrpyted = btoa(encrpytion1);
  return encrpyted;
}
